import React from 'react';
import { IconProps } from '.';

type GoOutIconProps = {
  color?: string;
} & IconProps;

export const GoOutIcon: React.FC<GoOutIconProps> = ({
  width = 24,
  height = 24,
  color = '#222427',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill={color}
        d="M.465 11.28a.387.387 0 010-.194.35.35 0 010-.193.688.688 0 01.097-.157l3.456-3.468a.496.496 0 01.7.7l-2.597 2.587h11.117a.495.495 0 110 .99H2.12l2.598 2.574a.495.495 0 01-.35.846.484.484 0 01-.351-.145L.562 11.4a.69.69 0 01-.097-.157"
      ></path>
      <path
        fill={color}
        d="M8.283 13.37a.495.495 0 01.496.495v5.486h7.19V5.177a.482.482 0 01.253-.422l5.92-3.348H8.78v6.888a.495.495 0 11-.991 0V.912a.495.495 0 01.495-.495h15.805a.495.495 0 01.495.495v18.91a.483.483 0 01-.374.472l-7.492 4.229a.423.423 0 01-.241.06.604.604 0 01-.254-.06.508.508 0 01-.254-.435v-3.77H8.283a.495.495 0 01-.495-.495v-5.958a.495.495 0 01.495-.495zm8.652 9.872l6.573-3.71V1.77l-6.573 3.697v17.775z"
      ></path>
    </svg>
  );
};
